"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertToBoolean = void 0;
const class_transformer_1 = require("class-transformer");
const booleanMapper = new Map([
    ['undefined', undefined],
    ['true', true],
    ['false', false],
]);
const ConvertToBoolean = () => (0, class_transformer_1.Transform)(({ value }) => booleanMapper.get(value));
exports.ConvertToBoolean = ConvertToBoolean;
